import data from "../../shared/sharedData";

export default {
  name: "Employer Information",
  prefix: "C",
  pageInfo: {
    text: "<strong><u>Important Note</strong></u>:  The information entered in this section must be the same as the employer information for the job opportunity on the Form ETA-9142C, Application for Temporary Employment Certification.",
    coloring: "grey",
  },
  sections: [
    {
      fields: [
        {
          widget: "inlinePrefiller",
          prefillLabel:
            "Select an Employer profile to populate this section (optional)",
          prefill: {
            schema: "employerProfiles",
            type: "employer",
            formName: "9141C",
            formSection: "C",
          },
        },
        {
          code: "C.1",
          machine_name: "empBusinessName",
          widget: "text",
          label: "Legal Business Name",
          maxLength: 120,
          validate: ["required", "noNAs"],
          tooltip: `Enter the full name of the individual employer, joint employer, job contractor, partnership, corporation, i.e., the employer filing this application.  The employer’s full legal business name is the exact name of the individual, corporation, LLC, partnership, or other organization that is reported to the Internal Revenue Service (IRS).`,
        },
        {
          code: "C.2",
          machine_name: "empTradeName",
          widget: "text",
          label: "Trade Name/Doing Business As (DBA), if applicable §",
          maxLength: 120,
          tooltip: `Enter the full trade name or “Doing Business As” (DBA) name, if applicable, of the business, person, association, firm, corporation, or organization, i.e., the employer filing this application.`,
        },
        {
          code: "C.3",
          machine_name: "empAddr1",
          widget: "text",
          label: "Address 1",
          maxLength: 60,
          validate: [
            "required",
            {
              minLength: 2,
              message: "Address 1 must contain at least 2 characters.",
            },
            "noNAs",
          ],
          tooltip: `Enter the business street address for the employer’s principal place of business.  The address must be a physical location. Since the address conventions in the CNMI do not always follow the entry formats generally for the continental United States, see the Address Note for CNMI at the end of these general instructions.`,
        },
        {
          code: "C.4",
          machine_name: "empAddr2",
          widget: "text",
          label: "Address 2",
          maxLength: 60,
          tooltip: `This field should contain the specific CNMI Island, as applicable.  If additional space is needed for the address or entry of a P.O. Box, use this field to complete the employer’s address.  If no additional space is needed, enter “N/A.”`,
        },
        {
          code: "C.8",
          machine_name: "empCountry",
          widget: "select",
          label: "Country",
          selection: data.country,
          validate: ["required"],
          clearSchema: ["empState"],
          tooltip: `Enter the country of the employer’s principal place of business.`,
        },
        {
          code: "C.5",
          machine_name: "empCity",
          widget: "text",
          label: "City",
          maxLength: 35,
          disabled: true,
          disableWhenField: "empCountry",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
            "noNAs",
          ],
          tooltip: `Enter the city of the employer’s principal place of business.`,
        },
        {
          code: "C.6",
          machine_name: "empState",
          widget: "select",
          label: "State",
          selection: data.state,
          state: true,
          disabled: true,
          disableWhenField: "empCountry",
          isVisible: {
            when: "empCountry",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
            hideStyles: true,
          },
          validate: [
            "required",
            {
              isRequired: "empCountry",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          tooltip:
            "Enter the State, District, or Territory of the employer’s principal place of business.",
        },
        {
          code: "C.6",
          machine_name: "empState",
          widget: "text",
          label: "State",
          maxLength: 30,
          disabled: true,
          disableWhenField: "empCountry",
          isVisible: {
            when: "empCountry",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "!==",
          },
          validate: ["required"],
          tooltip:
            "Enter the State, District, or Territory of the employer’s principal place of business.",
        },
        {
          code: "C.7",
          machine_name: "empPostcode",
          widget: "text",
          label: "Postal Code",
          maxLength: 10,
          disabled: true,
          disableWhenField: "empCountry",
          validate: [
            "required",
            {
              postalCountry: "empCountry",
              needsFieldValues: true,
              extraData: {
                valueOf: "empCountry",
              },
            },
            {
              isRequired: "empCountry",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          tooltip: `Enter the postal (zip) code of the employer’s principal place of business.`,
        },
        {
          code: "C.9",
          machine_name: "empProvince",
          widget: "text",
          label: "Province (if applicable) §",
          maxLength: 25,
          disabled: true,
          disableWhenField: "empCountry",
          validate: [
            {
              isRequired: "empCountry",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
          ],
          // isVisible: {
          //   when: "empCountry",
          //   is: ["UNITED STATES OF AMERICA", "- Select -", ""],
          //   operator: "!==",
          //   hideStyles: true,
          // },
          tooltip: `Enter the province of the employer’s principal place of business, if applicable.  Enter “N/A” if not applicable.`,
        },
        {
          code: "C.10",
          machine_name: "empPhone",
          widget: "phone",
          label: "Telephone number",
          validate: ["required", "phone"],
          tooltip: `Enter the area code and telephone number for the employer’s principal place of business.  Include country code, if outside of the United States.`,
        },
        {
          code: "C.11",
          machine_name: "empPhoneext",
          widget: "text",
          label: "Extension (if applicable) §",
          maxLength: 4,
          tooltip: `Enter the extension of the telephone number for the employer’s principal place of business, if applicable.  Enter “N/A” if not applicable.`,
        },
        {
          code: "C.12",
          machine_name: "empFein",
          widget: "text",
          label: "Federal Employer Identification Number (FEIN from IRS) ",
          maxLength: 10,
          validate: [
            "required",
            "fein",
            { minLength: 10, message: "This is not a valid FEIN" },
            {
              FEINPrefixValidator: "empFein",
              needsFieldValues: true,
              message: "This is not a valid FEIN",
            },
            "noNAs",
          ],
          tooltip: `Enter the nine-digit Federal Employer identification Number (FEIN) as assigned by the IRS.  <u>Do not enter a social security number</u>. 
          <br><strong><u>Important Note:</u></strong> All employers, <u>including private households</u>, MUST obtain an FEIN from the IRS before completing this application.  Information on obtaining an FEIN can be found at <a href="https://www.irs.gov/" rel="noopener noreferrer" target="_blank"><u>www.irs.gov</u></a>.`,
          parse: "fein",
        },
        {
          code: "C.13",
          machine_name: "empNaicsDesc",
          widget: "text",
          label: "NAICS Description",
          maxLength: 105,
          hidden: true,
        },
        {
          code: "C.13",
          machine_name: "empNaics",
          widget: "naics",
          label: "NAICS Code",
          maxLength: 6,
          field_to_modify: "empNaicsDesc",
          validate: ["required", "noNAs"],
          tooltip: `Enter the four- to six- digit eight North American Industry Classification System (NAICS) code that best describes the employer’s business, not the CW-1 job opportunity.  A listing of NAICS codes can be found at <a href="https://www.census.gov/naics/" rel="noopener noreferrer" target="_blank"><u>www.census.gov/naics/</u></a>.`,
        },
      ],
    },
  ],
};
